import { render, staticRenderFns } from "./categoryManagerPage.vue?vue&type=template&id=13f70231&"
import script from "./categoryManagerPage.vue?vue&type=script&lang=js&"
export * from "./categoryManagerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports